import { useState } from 'react'
import { Switch } from '@headlessui/react'
import { Control, useController } from 'react-hook-form'
import classNames from 'classnames'

export function FullWidthToggle({
  name,
  control,
}: {
  name: string
  control: Control<any>
}) {
  const { field } = useController({ name, control })

  const { onChange, value } = field

  return (
    <Switch.Group as="div" className="flex items-center">
      <Switch
        checked={Boolean(value)}
        onChange={onChange}
        className={classNames(
          value ? 'bg-teal-600' : 'bg-gray-200',
          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            value ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          )}
        />
      </Switch>
      <Switch.Label as="span" className="ml-3 text-sm">
        <span className="text-sm font-medium text-gray-700">Full width</span>{' '}
        {/* <span className="text-gray-500">(rec'd for long text only)</span> */}
      </Switch.Label>
    </Switch.Group>
  )
}
